<template>
    <div class="testimonial-wrapper">
        <div class="testimonial-quotes">"</div>
        <div class="testimonial-author">{{ testimonial.author }}</div>
        <div class="testimonial-title">{{ testimonial.title }}</div>
        <div class="testimonial-desc">{{ testimonial.desc }}</div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'Testimonial',
        props: {
            testimonial: {
                type: Object
            }
        }
    })
</script>

<style scoped lang="scss">
    .testimonial {
        &-wrapper {
            color: #fff;
            width: 100%;
            position: relative;
        }

        &-quotes {
            font-size: 8rem;
            line-height: 1.5rem;
            font-style: italic;
        }

        &-author {
            font-size: .8rem;
            letter-spacing: 1px;
            margin-bottom: .5rem;
        }

        &-title {
            font-size: 1.3rem;
            font-weight: bold;
            margin-bottom: .5rem;
            letter-spacing: .5px;
        }

        &-desc {
            line-height: 1.3rem;
            text-align: justify;
        }
    }

</style>